import React from 'react';
import Payments from '@/features/payments/manage/components/Payments';

const ManagePaymentPage = () => <Payments />;

export default ManagePaymentPage;
